import { FunctionComponent } from "react";
import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import Footer from "../../../components/footer";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import StatementLocatedImage from "../../../assets/images/statement-located.png";
import StatementLocatedImageWebp from "../../../assets/images/statement-located.webp";
import VectorWrapper from "../../../components/vector-wrapper";
import useImageLoader from "../../../utils/useLoadImage";
import LoadingScreen from "../../general/loading-screen";
import { HeadlineMedium } from "../../../components/font";
import HeadingContainer from "../../../layout/heading-container";
import { Button } from "@manifesthhqinc/ui-library";

const AccountStatementSucceed: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const { currentSourceAccountStep, onClickContinue, setIsSaving, isSaving } = props;
  const { imageSrc, webpSrc } = useImageLoader({ imgSrc: StatementLocatedImage, webp: StatementLocatedImageWebp });

  const onClickContinueHandler = () => {
    setIsSaving(true);
    onClickContinue();
  };

  if (process.env.NODE_ENV !== "test" && !imageSrc && !webpSrc) {
    return <LoadingScreen loadingScreenMessage="" />;
  }

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <HeadingContainer paneVariant="vector" withProgressBar>
            <HeadlineMedium $textAlign="center">Well done on locating your statement!</HeadlineMedium>
          </HeadingContainer>
          <VectorWrapper
            imgSrc={imageSrc}
            webpSrc={webpSrc}
            imgAlt="well done locating statement"
            name={"statement-succeed"}
          />
        </Container>
      </ScrollableContainer>
      <Footer>
        <p className="form-description-with-vector pl-0 pr-0 disclaimer-text no-max-width">
          Every provider has unique transfer needs. We'll now check your account details to ensure a seamless transfer
          process.
        </p>
        <Button name="continueUploadStatement" onClick={onClickContinueHandler} isLoading={isSaving} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default AccountStatementSucceed;
